import { useMutation } from '@apollo/client';
import { Card, CardTitle } from 'components/Card/Card';
import { MemberBox } from 'components/MemberBox/MemberBox';
import { useToast } from 'components/Toast/use-toast';
import { normalizeArray } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import { COMPANY_MEMBER_BALANCE_TRANSFER } from 'services/companies/mutation';
import { useCompanyStore } from 'stores/company.store';

export const CompanyMembersPreview = () => {
    const company = useCompanyStore(state => state.company);
    const getCompany = useCompanyStore(state => state.getCompany);
    const { t } = useTranslation('company');
    const { toast } = useToast();
    const [transferBalance] = useMutation(COMPANY_MEMBER_BALANCE_TRANSFER);

    if (!company?.members) return null;

    const handleTransfer = async (member: any) => {
        const amount = member.balance?.amount || 0;
        const currency = member.balance?.currency || 'CHF';
        const confirmed = window.confirm(
            t('transferConfirm', {
                amount: `${currency} ${Number(amount).toFixed(2)}`,
                member: `${member.firstName} ${member.lastName}`,
                company: company.name,
            })
        );
        if (!confirmed) return;

        try {
            const { data, errors } = await transferBalance({
                variables: { company: company.id, member: member.id },
            });
            if (errors?.length) {
                toast({ description: errors[0].message, variant: 'warning' });
                return;
            }
            if (data?.companyMemberBalanceTransfer?.success) {
                toast({ description: t('transferSuccess'), variant: 'success' });
                getCompany(company.id);
            }
        } catch (e: any) {
            toast({ description: e.message || t('transferFail'), variant: 'warning' });
        }
    };

    return (
        <Card className="flex flex-col gap-8">
            <CardTitle>{t('companyMembersTitle')}</CardTitle>
            <div className="grid grid-cols-2 gap-6">
                {normalizeArray(company?.members).map((member: any) => (
                    <MemberBox
                        member={member}
                        key={member.id}
                        onTransferBalance={handleTransfer}
                    />
                ))}
            </div>
        </Card>
    );
};
